/** Normalize malformed ISO strings (e.g. `+00:00Z` with both offset and Z). */
export function normalizeIsoDateString(input: string): string {
  let s = input.trim().replace(/\s*UTC$/i, "Z");
  if (/[+-]\d{2}:\d{2}Z$/i.test(s)) {
    s = s.slice(0, -1);
  }
  return s;
}

export function parseDateTime(input: string | null | undefined): Date | null {
  if (!input?.trim()) return null;
  let s = normalizeIsoDateString(input);
  s = s.replace(" ", "T");
  if (s.includes("T") && !/[zZ]$/.test(s) && !/[+-]\d{2}:?\d{2}$/.test(s)) {
    s += "Z";
  }
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

/** Local datetime like "Jun 23, 3:30 PM". Invalid/unparseable → "". */
export function formatDateTime(input: string | null | undefined): string {
  const d = parseDateTime(input);
  if (!d) return "";
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
